import * as React from "react";
import { SVGProps, memo } from "react";

const SvgNotFound = (props: SVGProps<SVGSVGElement>) => (
  <svg width={70} height={72} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m24.966 42.461 5.525 5.732L5.94 70.5l-4.644-5.53 23.67-22.509Z" fill="#C2CCC5" />

    <path
      opacity={0.3}
      d="M65.903 27.581a22.93 22.93 0 1 1-45.81-2.144 22.93 22.93 0 0 1 45.81 2.144Z"
      fill="#fff"
    />

    <path
      opacity={0.4}
      d="M55.897 7.543 22.852 37.679a47.234 47.234 0 0 1-.488-.924 22.669 22.669 0 0 1-2.082-6.415l28.54-26.03a22.847 22.847 0 0 1 7.075 3.233ZM64.739 19.224 33.69 47.555a22.96 22.96 0 0 1-8.332-6.261l33.926-30.941a22.99 22.99 0 0 1 5.454 8.87Z"
      fill="#fff"
    />

    <path
      d="M65.893 13.27A26.518 26.518 0 1 0 19.95 39.767 26.518 26.518 0 0 0 65.893 13.27Zm-41.06 23.712a20.91 20.91 0 1 1 5.383 6.135 20.906 20.906 0 0 1-5.379-6.135h-.004Z"
      fill="#C2CCC5"
    />

    <path
      opacity={0.1}
      d="M65.893 13.27A26.518 26.518 0 1 0 19.95 39.767 26.518 26.518 0 0 0 65.893 13.27Zm-41.06 23.712a20.91 20.91 0 1 1 5.383 6.135 20.906 20.906 0 0 1-5.379-6.135h-.004Z"
      fill="#000"
    />
  </svg>
);

const Memo = memo(SvgNotFound);

export default Memo;
